export const READ_SALE_SETTING_CODE = 196012;
export const UPDATE_SALE_SETTING_CODE = 196013;
export const SALE_SETTING_PATH = "/sale/setup/sale-setting";
export const SALE_SETTING_ALLOW_ITEM_PRICE_MODIFICATION = "allowItemPriceModification";
export const SALE_SETTING_ALLOW_CUSTOMER_COMMISSION = "allowCustomerCommission";
export const SALE_SETTING_ALLOW_TO_USE_CUSTOMER_COMMISSION = "allowToUseCustomerCommission";
export const SALE_SETTING_SALE_TAX = "saleTax";
export const SALE_SETTING_DEPOSIT_ITEM = "depositItem";
export const SALE_SETTING_ALLOW_MANUAL_DATE = "allowManualDate";
export const SALE_SETTING_MANUAL_SALE_ORDER_NO_TYPE = "manualSaleOrderNoType";

export const MANUAL_NO_TYPE_NO_SERIES_LIST = "NoSeriesList";
export const MANUAL_NO_TYPE_MANUAL = "Manual";

export const MANUAL_SALE_ORDER_NO_TYPE_DATA_SOURCE = [
  {
    id: MANUAL_NO_TYPE_NO_SERIES_LIST,
    name: "No Series List",
  },
  {
    id: MANUAL_NO_TYPE_MANUAL,
    name: "Manual",
  },
];

export const SALE_SETTING_SUBMIT_RULES = (values) => {
  const { isAccountingInstalled } = values;
  return {
    defaultPaymentTerm: {
      type: "object",
      value: {
        required: true
      }
    },
    saleTax: {
      type: "object",
      value: {
        required: true
      }
    },
    defaultPriceList: {
      type: "object",
      value: {
        required: true
      }
    },
    defaultCostChartAccount: {
      type: "object",
      value: {
        required: isAccountingInstalled
      }
    },
    defaultSaleChartAccount: {
      type: "object",
      value: {
        required: isAccountingInstalled
      }
    },
    expenseBidChartAccountConfiguration: {
      type: "object",
      value: {
        required: isAccountingInstalled
      }
    }
  };
};